import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-job-change-alert-modal',
  templateUrl: './job-change-alert-modal.component.html',
  styleUrls: ['./job-change-alert-modal.component.scss']
})
export class JobChangeAlertModalComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
